import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {css, styled} from 'styled-components'

export const StyledTimeSlotRowContainer = styled(Grid)(
    ({theme: {spacing}}) => css`
        width: 300px;
        padding: ${spacing * 4}px 0;
    `
)
